import logoutMiddleware from './middlewares/logout';

const storeExtender = (middleware) => {
  return [...middleware, logoutMiddleware];
};

export default storeExtender;